import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {notifiesApi} from '../../api';
import {createQuery} from '../../lib';
import { AxiosError } from 'axios';

const {getAllForUser} = notifiesApi.notifications;

export type GetNotificationsQueryParams = string;

const getNotificationsRefresh = atom<number>({
  key: 'getNotificationsRefresh',
  default: 0,
});

const getNotificationsQuery = selectorFamily({
  key: 'getNotifications',
  get(uid: GetNotificationsQueryParams) {
    return async ({get}) => {
      get(getNotificationsRefresh);

      if (!uid) {
        return [];
      }

      try {
        const {data, status} = await getAllForUser({uid});

        if (status === 204) {
          return [];
        }

        return data;
      } catch (e) {
        if (e instanceof AxiosError && e?.response && (e?.status || 0) >= 500) {
          e.response.data = {
            title: 'Произошла ошибка',
            message: 'Сервис уведомлений недоступен'
          }
        }

        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetNotificationsQuery = createQuery(getNotificationsQuery, getNotificationsRefresh);
